import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UpdateDependentCheckboxPayload {
  id: string;
  checked: boolean;
}

interface UpdateHideDependentCheckboxPayload {
  dependentId: string;
  value: boolean;
}

interface PCPFamilyInfoLogicProps {
  isSubscriberCheckboxChecked: boolean;
  isEnableChooseProviderBtn: boolean;
  isDependentCheckboxChecked: { [key: string]: boolean };
  dependentCheckboxCheckedId: string;
  subscriberProviderItems: any;
  dependentProviderItems: any;
  isSubscriberExistingPatientCheck: boolean;
  isChooseProviderDrawerOpen: boolean;
  isSelectProviderDrawerOpen: boolean;
  isChoosePCPDrawerOpen: boolean;
  specialityDropdownOptions: any[];
  storePcpDentalData: any;
  hideSubscriberCheckboxWhenChecked: boolean;
  showSelectedChangeDependent: boolean;
  hideDependentCheckboxes: { [key: string]: boolean };
}

const initialState: PCPFamilyInfoLogicProps = {
  isSubscriberCheckboxChecked: false,
  isEnableChooseProviderBtn: true,
  isDependentCheckboxChecked: {},
  dependentCheckboxCheckedId: '',
  subscriberProviderItems: {},
  dependentProviderItems: [],
  isSubscriberExistingPatientCheck: false,
  isChooseProviderDrawerOpen: false,
  isSelectProviderDrawerOpen: false,
  isChoosePCPDrawerOpen: false,
  specialityDropdownOptions: [],
  storePcpDentalData: {},
  hideSubscriberCheckboxWhenChecked: true,
  showSelectedChangeDependent: true,
  hideDependentCheckboxes: {},
};

const PCPFamilyInfoLogicSlice = createSlice({
  name: 'SET_PCP_FAMILY_INFO_LOGIC',
  initialState,
  reducers: {
    setSubscriberCheckbox: (state, action: PayloadAction<boolean>) => {
      state.isSubscriberCheckboxChecked = action.payload;
    },
    setEnableChooseProviderButton: (state, action: PayloadAction<boolean>) => {
      state.isEnableChooseProviderBtn = action.payload;
    },
    setCheckedDependentCheckbox: (
      state,
      action: PayloadAction<UpdateDependentCheckboxPayload>
    ) => {
      const { id, checked } = action.payload;
      state.isDependentCheckboxChecked[id] = checked;
    },
    setCheckedDependentCheckboxId: (state, action: PayloadAction<string>) => {
      state.dependentCheckboxCheckedId = action.payload;
    },
    setSubscriberProviderItems: (state, action: PayloadAction<any>) => {
      state.subscriberProviderItems = action.payload;
    },
    setDependentProviderItems: (state, action: PayloadAction<any>) => {
      state.dependentProviderItems = action.payload;
    },
    setCheckSubscriberExistingPatientCheckbox: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isSubscriberExistingPatientCheck = action.payload;
    },
    setOpenChooseProviderDrawer: (state, action: PayloadAction<boolean>) => {
      state.isChooseProviderDrawerOpen = action.payload;
    },
    setOpenSelectProviderDrawer: (state, action: PayloadAction<boolean>) => {
      state.isSelectProviderDrawerOpen = action.payload;
    },
    setOpenChoosePCPDrawer: (state, action: PayloadAction<boolean>) => {
      state.isChoosePCPDrawerOpen = action.payload;
    },
    setSpecialityDropdownOptions: (state, action: PayloadAction<any>) => {
      state.specialityDropdownOptions = action.payload;
    },
    setPcpDentalData: (state, action: PayloadAction<any>) => {
      state.storePcpDentalData = action.payload;
    },
    setHideSubscriberCheckboxWhenChecked: (state, action: PayloadAction<boolean>) => {
      state.hideSubscriberCheckboxWhenChecked = action.payload;
    },
    setShowSelectedChangeDependent: (state, action: PayloadAction<boolean>) => {
      state.showSelectedChangeDependent = action.payload;
    },
    setHideCheckedDependentCheckbox: (
      state,
      action: PayloadAction<UpdateHideDependentCheckboxPayload>
    ) => {
      if (action.payload.value) {
        state.hideDependentCheckboxes[action.payload.dependentId] = true;
      }
    }
  },
});

const { reducer, actions } = PCPFamilyInfoLogicSlice;

export const {
  setSubscriberCheckbox,
  setEnableChooseProviderButton,
  setCheckedDependentCheckbox,
  setCheckedDependentCheckboxId,
  setSubscriberProviderItems,
  setDependentProviderItems,
  setCheckSubscriberExistingPatientCheckbox,
  setOpenChooseProviderDrawer,
  setOpenSelectProviderDrawer,
  setOpenChoosePCPDrawer,
  setSpecialityDropdownOptions,
  setPcpDentalData,
  setHideSubscriberCheckboxWhenChecked,
  setShowSelectedChangeDependent,
  setHideCheckedDependentCheckbox
} = actions;

export const PCPFamilyInfoLogicReducer = reducer;
